import React from 'react';
import PropTypes from 'prop-types';

const Spinner = (props) => {
  const size = { large: '40px', normal: '20px', small: '10px' }[props.size];
  return (
    <div className="spinner">
      <span className="primary--border-top" style={{ width: size, height: size }} />
      {props.text &&
        <p className="primary spinner__text">{props.text}</p>
      }
    </div>
  );
};

Spinner.propTypes = {
  size: PropTypes.oneOf(['large', 'normal', 'small']),
  text: PropTypes.string,
};
Spinner.defaultProps = {
  size: 'normal',
};


export default Spinner;



// WEBPACK FOOTER //
// ./src/components/spinner.js